import { render } from "./Documents.vue?vue&type=template&id=3d4ebaf8&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=3d4ebaf8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d4ebaf8"

export default script